/**
 * Shared Handlebars helpers for client-side templates.
 *
 * Used by GridJS column formatters and available to Vue components that
 * need the same badge/link markup. Vue handles complex reactive UI;
 * Handlebars remains the lightweight choice for table cell templates.
 */
import Handlebars from "handlebars"

Handlebars.registerHelper("eq", (a, b) => a === b)

export function compileTemplate(source) {
  return Handlebars.compile(source)
}

export { Handlebars }
